module.exports = __webpack_public_path__ + "img/map3.5cf2b452.jpg";